<template>
  <i18n path="e-mobility.electricity-installation-form.myORESRedirection.intro" tag="p">
    <template #link>
      <a href="https://www.myores.be" target="_blank">
        {{ $t('e-mobility.electricity-installation-form.myORESRedirection.link') }}
      </a>
    </template>
  </i18n>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'myores-redirection-link'
})
export default class MyORESRedirectionLink extends Vue { }
</script>